import { Directive, ElementRef } from '@angular/core';
import { NgModel } from '@angular/forms';
import * as $ from 'jquery';

@Directive({
  selector: 'select[ngModel]',
  providers: [NgModel]
})

export class FieldInitializationDirective {
  constructor(private elem: ElementRef, private ngModel: NgModel) {
  }

  ngAfterViewInit() {
    let that = this;

    //Case: For 'Dropdown' field
    if(that.elem.nativeElement.tagName==='SELECT'){
      //Set model to 'Pick an Option' using setTimeout() to escape 'ExpressionChangedAfterItHasBeenCheckedError'. Reference: https://bit.ly/2v7ktHo
      setTimeout(() => {
        if(that.ngModel.value===null){
          that.ngModel.update.emit(undefined);
        }
      }, 300);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/fieldInitialization.directive.ts